// extracted by mini-css-extract-plugin
module.exports = {"info":"index-module--info--2DvpV","feedback":"index-module--feedback--1BrAy"};